<script>
import axios from 'axios';
export class ErrorService {
    static handleError(error, instance, info) {
        console.log(instance.$);
        const formData = new FormData();
        formData.append('error', error.toString());
        //formData.append('instance', instance);
        formData.append('source', instance?.$?.type?.__file);
        axios
            .post(
                this.apiUrl() +
                    'API/ErrorHandling.php?apiUnique='+this.apiUniqueNumber, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
            })
            .then(response => {
                console.log("---");
                console.log(response.data);
                console.log("---");
            }).catch(
                function (error) {
                console.log('Show error notification!')
                    return Promise.reject(error)
                }
            );
    }

    static apiUrl() {
        return import.meta.env.VITE_API_PATH;
    }

    static apiUniqueNumber() {
        return Math.ceil(Math.random()*1000000);
    }
}
</script>
